//UPDATE LIVRAISON
//export const REST_API_URL = "http://localhost:8080/api/";
export const REST_API_URL = "/gpmg/api/";
export const APP_PATH = "/gpmg";

//UPDATE LIVRAISON
export const PORTAL_URL = "https://rec.gpmg.neogeo.fr/";
//export const PORTAL_URL = "https://sig.port-guadeloupe.fr/";

//export const CARTO_URL = (window.location.origin === "http://localhost"
//                       || window.location.origin === "http://10.1.0.81") ? "http://172.16.20.9/geoportail/index.html" : "/geoportail/index.html";
// export const CARTO_URL = "http://10.1.0.81/geoportail2/index.html";
// export const CARTO_URL = "/geoportail/index.html";

//UPDATE LIVRAISON
export const CARTO_URL = PORTAL_URL + "/maps/#/map/[idcarte]?bbox=-61.66585169034849,16.200519399483397,-61.48551764534092,16.274555055116394"
//export const CARTO_URL = "http://localhost:8081/#/map/[idcarte]?bbox=-61.66585169034849,16.200519399483397,-61.48551764534092,16.274555055116394"

export const PERMISSION_CREATE = "create";
export const PERMISSION_READ = "read";
export const PERMISSION_UPDATE = "update";
export const PERMISSION_DELETE = "delete";

export const ADMIN_ROLES = ["Administrateur"];

export const UNITE = {
  FORFAIT: "forfait",
};

export const UNITE_TEMPS = {
  YEAR: "Année",
  MONTH: "Mois",
  WEEK: "Semaine",
  DAY: "Jour",
};



// WEBPACK FOOTER //
// ./src/Utils/Global.js